// @ts-nocheck

import { createCachedSelector } from 're-reselect';
import { createSelector } from 'reselect';

const defaultSection = 'general';

export const getReportingAdvancedStore = store => store.reportingAdvancedFilter;

export const getSectionKey = (_, section) => section || defaultSection;

const getMapKey = (_state, section, mapId) => {
  const currentSection = section || defaultSection;
  const currentMapId = mapId || '';

  return `${currentSection}|${currentMapId}`;
};

export const getCampaigns = createSelector([getReportingAdvancedStore], moduleStore => moduleStore.cids);

export const getCurrency = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].currency || state.sections[defaultSection].currency
)(getSectionKey);

export const getTimeRange = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].timeRange || state.sections[defaultSection].timeRange
)(getSectionKey);

export const getTimeFrame = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].timeFrame || state.sections[defaultSection].timeFrame
)(getSectionKey);

export const getTimeZone = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].timeZone || state.sections[defaultSection].timeZone
)(getSectionKey);

export const getCartographyCountries = createCachedSelector(getReportingAdvancedStore, getMapKey, (state, options) => {
  const [section, mapId = ''] = options.split('|');
  const defaultValues = state.sections[defaultSection].cartographyCountries;
  const sectionValues = mapId
    ? state.sections[section][mapId].cartographyCountries
    : state.sections[section].cartographyCountries;
  if (!sectionValues.length && defaultValues.length) {
    return defaultValues;
  }
  return sectionValues;
})(getMapKey);

export const getCartographyLevel = createCachedSelector(getReportingAdvancedStore, getMapKey, (state, options) => {
  const [section, mapId = ''] = options.split('|');
  const defaultValue = state.sections[defaultSection].cartographyLevel;
  const sectionValue = mapId
    ? state.sections[section][mapId].cartographyLevel
    : state.sections[section].cartographyLevel;
  return sectionValue || defaultValue;
})(getMapKey);

export const getCartographyLevelIds = createCachedSelector(getReportingAdvancedStore, getMapKey, (state, options) => {
  const [section, mapId = ''] = options.split('|');
  const defaultValues = state.sections[defaultSection].cartographyLevelIds;
  const sectionValues = mapId
    ? state.sections[section][mapId].cartographyLevelIds
    : state.sections[section].cartographyLevelIds;
  if (!sectionValues.length && defaultValues.length) {
    return defaultValues;
  }
  return sectionValues;
})(getMapKey);

export const getVariableType = createCachedSelector(getReportingAdvancedStore, getSectionKey, (state, section) => {
  const defaultValue = state.sections[defaultSection].variableType;
  const sectionValue = state.sections[section].variableType;
  return sectionValue || defaultValue;
})(getSectionKey);

export const getVariableValues = createCachedSelector(getReportingAdvancedStore, getSectionKey, (state, section) => {
  const defaultValues = state.sections[defaultSection].variableValues;
  const sectionValues = state.sections[section].variableValues;
  if (!sectionValues.length && defaultValues.length) {
    return defaultValues;
  }
  return sectionValues;
})(getSectionKey);

export const getAdvancedFilters = createCachedSelector(getReportingAdvancedStore, getSectionKey, (state, section) => {
  const { cids } = state;
  const {
    cartographyCountries,
    cartographyLevel,
    cartographyLevelIds,
    cartographyLevelIdsNames,
    chartTimeStep,
    currency,
    tablesTimeStep,
    timeFrame,
    timeRange,
    timeZone,
    variableType,
    variableValues,
    variableValuesNames
  } = state.sections[section];
  return {
    cartographyCountries,
    cartographyLevel,
    cartographyLevelIds,
    cartographyLevelIdsNames,
    chartTimeStep,
    cids,
    currency,
    tablesTimeStep,
    timeFrame,
    timeRange,
    timeZone,
    variableType,
    variableValues,
    variableValuesNames
  };
})(getSectionKey);

export const getTablesTimeStep = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].tablesTimeStep
)(getSectionKey);

export const getChartTimeStep = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].chartTimeStep
)(getSectionKey);

export const getBeginDate = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].timeFrame.beginDate
)(getSectionKey);

export const getEndDate = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].timeFrame.endDate
)(getSectionKey);

export const getCountry = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section].country
)(getSectionKey);

export const getInsightCountry = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, insightId) => state.sections.insights.insightCountry?.[insightId]
)(getSectionKey);

export const getSection = createCachedSelector(
  getReportingAdvancedStore,
  getSectionKey,
  (state, section) => state.sections[section]
)(getSectionKey);
